export const AppContextConstants = {
  OBJECT: 'object',
  COID: 'coid',
  COMPANY_ID: 'companyid',
  EMPTY_STRING: '',
  JWT_TOKEN: 'jwtToken',
  CONTACT_NAME_AND_ADDRESS: 'contactNameAndAddress',
  CONTACT_PHONE: 'contactPhone',
  CONTACT_EMAIL: 'contactEmail',
  CONTACT_FAX: 'contactFax',
  CONTACT_URL: 'contactUrl',
  CONTACT_LOGO_PATH: 'contactLogoPath',
  PUBLISH_NAME: 'publishName',
  AUTH_STORAGE_KEY: 'borrower_app_state',
};
